import { HttpClient, HttpContext } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";

import { Packaging } from "@hermes/api-model-packaging";
import { ProductEnvironment } from "@hermes/api-model-product-environment";
import { LOCALE, Settings } from "@hermes/app-core";
import { Locale } from "@hermes/locale";
import { Logger } from "@hermes/logger";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils/constants";
import { LOGGER } from "@hermes/web-logger";

@Injectable()
export class AgecService {
    constructor(
        private httpClient: HttpClient,
        private settings: Settings,
        @Inject(LOGGER) private logger: Logger,
        @Inject(LOCALE) private locale: Locale,
    ) {}

    public getProductBySKU(sku: string): Observable<ProductEnvironment> {
        return this.httpClient.get<ProductEnvironment>(
            `${this.settings.apiUrl}/environment/product`,
            {
                params: { sku },
                headers: {
                    ["accept-language"]: this.locale.code,
                },
            },
        );
    }

    public getPackagings(): Observable<Packaging[]> {
        // If there is a 404 call to "/environment/packagings/"  we don"t want to redirect to a 404 page
        // but only not show the packagings
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);
        return this.httpClient
            .get<Packaging[]>(
                `${this.settings.apiUrl}/environment/packagings`,
                {
                    headers: {
                        ["accept-language"]: this.locale.code,
                    },
                    context,
                },
            )
            .pipe(
                catchError(() => {
                    this.logger.error(
                        "Error occured when getting environment packagings",
                    );
                    return of([]);
                }),
            );
    }
}
